module.exports = __webpack_public_path__ + "static/15-25d15af9c76307c35b7f9b8746106d93.png";